import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import * as _ from 'lodash';

import { SearchService } from 'shared/search/search.service';
import { SearchModel } from 'shared/search/search.model';
import {BehaviorSubject} from 'rxjs';

@Injectable()
export class AssignedSearchService extends SearchService {

  // extendable fields:
  searchModel: SearchModel = new SearchModel();
  _searchModel: BehaviorSubject<SearchModel> = new BehaviorSubject(this.searchModel);


  assetId: string = '';

  // public:
  getSearchURI(brandId: string, searchModel: SearchModel): string {
    return `/assets/${brandId}/${this.assetId}/assignments`;
  }

  getQueryString(searchModel: SearchModel): string {
    const sortCol: string = (searchModel.sortModel) ? searchModel.sortModel.column : '';
    const sortDir: string = (searchModel.sortModel) ? searchModel.sortModel.sort : '';
    const queryString: string =
      'page=' + searchModel.currentPage +
      '&itemsPerPage=' + searchModel.itemsPerPage +
      '&search=' + searchModel.searchValue +
      '&sortCol=' + sortCol +
      '&sortDir=' + sortDir;

    return queryString;
  }

  runSearchAssigned(brandId: string, assetId: string): Promise<any> {
    this.assetId = assetId;
    return new Promise<void>(resolve => {
      this.runSearch(brandId, this.searchModel)
      .subscribe((searchResults: any) => {
        _.each(searchResults.data, (result: any) => {
          result.thumbnail = result.part_image_small;
        });
        resolve();
      });
    });
  }

  clearSearchModel() {
    this.searchModel = new SearchModel();
  }
}
